











































































































































































































































































































import Vue from 'vue';
import WbContentWrapper from '@/components/content_wrapper/index.vue';
import WbDatePickerSingle from '@/components/date_picker_single/index.vue';
import getOrder from './dependencies/get_order';
import WbDialog from '@/components/dialog/index.vue';
import WbSelect from '@/components/select/index.vue';
import { blockAccount } from './dependencies/block_account_from_being_sent';
import { unblockAccount } from './dependencies/unblock_account_from_being_sent';
import { recallAccount } from './dependencies/recall_account';
import { getDelinquentReadableState, DelinquencyState } from '../../../dependencies/get_delinquent_readable_state';
import { getDelinquentAccount, DelinquentAccount } from './dependencies/get_delinquent_account';
import { formatDate } from '@/filters/date';
import { updateOrder } from './dependencies/update_order';
import { updateDueDate } from './dependencies/updateDueDate';
import WbOrder from '../../../order/index.vue';

interface Info {
  id: string;
  currency: string;
  priceInCents: number;
  installments: number;
  productName: string;
  studentId: string;
  studentName: string;
  projectId: string;
  projectName: string;
  agreementFileName: string;
  agreementLink: string;
  delinquencyStatus: string;
  agency: string;
  sentAt: Date;
  archivedAt: Date;
  status: string;
  loanBalanceInDollars: string;
  origin: 'ppm' | 'lnpl';
}

interface Installments {
  id: string;
  status: string;
  currency: number;
  amountInCents: number;
  dueDate: Date;
  updatedAt: Date;
  paidAt: string;
  bluesnapTransactionId: string;
}

interface PaymentDetails {
  card?: {
    type: 'credit' | 'debit' ;
    brand: string;
    lastFourDigits: string;
    expirationMonth: string;
    expirationYear: string;
  };
  bank?: {
    accountType: string;
    lastFiveDigitsAccountNumber: string;
    lastFiveDigitsRoutingNumber: string;
  };
}

interface StatusListOption {
  value: string;
  text: string;
}

export default Vue.extend({

  components: {
    WbOrder,
    WbDialog,
    WbSelect,
    WbDatePickerSingle,
    WbContentWrapper,
  },
  data() {
    return {
      installmentDateUpdate: '',
      achError: '',
      order: {
        info: { id: 'asd' } as Info,
        installments: [] as Installments[],
        reversalDate: '' as string,
        paymentDetails: {} as PaymentDetails,
      },
      delinquentAccount: {} as DelinquentAccount,
      delinquencyState: '',
      state: '',
      table: {
        itemsPerPage: 25,
        headers: [
          { text: 'Due Date', value: 'dueDate', sortable: false },
          { text: 'Retry Date', value: 'retryDate', sortable: false },
          { text: 'Amount', value: 'amount', sortable: false },
          { text: 'Status', value: 'status', sortable: false },
          { text: 'Paid Date', value: 'paidAt', sortable: false },
          { text: 'BlueSnap ID', value: 'bluesnapTransactionId', sortable: false },
          { text: 'Last Modified At', value: 'updatedAt', sortable: false },
          { text: 'Change', value: 'change', sortable: false },
        ],
      },
      recallDialog: false,
      blockFromBeingSentDialog: false,
      unblockFromBeingSentDialog: false,
      errorSnackbar: false,
      errorText: '',
      changeStatusDialogState: false,
      changeStatusLoading: false,
      changeStatusErrorMessage: '',
      changeStatusOption: '',
      statusList: [] as StatusListOption[],

      changeAchDialog: false,
      changeAchDialogStagedId: '',
      changeAchDialogStagedDate: '',
      changeAchDialogState: '',
    };
  },

  computed: {
    delinquencyStates: () => DelinquencyState,
  },

  mounted() {
    this.getData().then(() => this.showAvailableStatusUpdate());
  },

  methods: {
    async getData() {
      try {
        this.state = 'loading';
        const data = await getOrder(this.$route.params.id);
        this.delinquentAccount = await getDelinquentAccount(this.$route.params.id);
        this.delinquencyState = getDelinquentReadableState(this.delinquentAccount);
        this.order = data;
        this.state = 'loaded';
      } catch (error) {
        this.state = 'error';
      }
    },

    updateDate(newDate: string) {
      this.installmentDateUpdate = newDate;
    },

    async updateInstallmentDueDate() {
      try {
        await updateDueDate(this.changeAchDialogStagedId, this.installmentDateUpdate);
        this.changeAchDialog = false;
        this.installmentDateUpdate = '';
        await this.getData();
      } catch (e) {
        this.changeAchDialogState = 'error';
        try {
          this.achError = `👋 ${(e as any).data.message}`;
        } catch (e) {
          this.achError = 'something went wrong';
        }
      }
    },

    async recallAccount() {
      try {
        this.recallDialog = false;
        await recallAccount(this.order.info.id);
        await this.getData();
      } catch (error) {
        this.errorText = 'error recalling account';
        this.errorSnackbar = true;
      }
    },

    async blockAccountFromBeingSent() {
      try {
        this.blockFromBeingSentDialog = false;
        await blockAccount(this.order.info.id);
        await this.getData();
      } catch (error) {
        this.errorText = 'error blocking account';
        this.errorSnackbar = true;
      }
    },

    async unblockAccountFromBeingSent() {
      try {
        this.unblockFromBeingSentDialog = false;
        await unblockAccount(this.order.info.id);
        await this.getData();
      } catch (error) {
        this.errorText = 'error unblocking account';
        this.errorSnackbar = true;
      }
    },

    getArchivedDate(account: DelinquentAccount) {
      if (account.archivedAt) {
        return formatDate(String(account.archivedAt), 'MMM dd, yyyy');
      }
      if (account.blockedFromCollectionsAt) {
        return formatDate(String(account.blockedFromCollectionsAt), 'MMM dd, yyyy');
      }

      return '';
    },

    showAvailableStatusUpdate() {
      const amountPaid = this.order.installments.reduce((p, c) => (
        c.status === 'paid' ? p + Number(c.amountInCents) : p
      ), 0);

      if (this.order.info.status === 'chargebacked') {
        this.statusList = [
          { value: 'chargeback_reversed', text: 'Reverse Chargeback' },
        ];
        return;
      }

      if (this.order.info.status !== 'paid' || amountPaid >= Number(this.order.info.priceInCents)) {
        this.statusList = [];
        return;
      }

      this.statusList = [
        { value: 'canceled', text: 'Canceled' },
        { value: 'chargeoff_bankrupt', text: 'Bankrupt' },
      ];
    },

    async changeOrderStatus() {
      this.changeStatusLoading = true;
      try {
        await updateOrder(this.$route.params.id, this.changeStatusOption);
      } catch (err) {
        if ((err as any).type) {
          this.errorText = (err as any).message;
        } else {
          this.errorText = 'Generic Error. Talk to dev team.';
        }
        this.errorSnackbar = true;
        return;
      } finally {
        this.changeStatusLoading = false;
        this.changeStatusDialogState = false;
        this.changeStatusOption = '';
      }
      await this.getData();
      this.showAvailableStatusUpdate();
    },

    openRecallDialog() {
      this.recallDialog = true;
    },

    openBlockDialog() {
      this.blockFromBeingSentDialog = true;
    },

    openUnblockDialog() {
      this.unblockFromBeingSentDialog = true;
    },

    openUpdateOrderDialog() {
      this.changeStatusDialogState = true;
    },
    showChangeAchDialog(id: string, date: string) {
      this.changeAchDialog = true;
      this.changeAchDialogStagedDate = date;
      this.changeAchDialogStagedId = id;
      this.achError = '';
    },
  },
});
